import { render } from "./InputRangeSlider.vue?vue&type=template&id=6aa0e540"
import script from "./InputRangeSlider.vue?vue&type=script&lang=js"
export * from "./InputRangeSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__